import axios from 'axios';

const wrapEntity = (data: any) => {
  if (data?.hasError !== undefined) {
    return data;
  }
  return { hasError: false, result: data, errorMessages: [] };
};

const platformUsageService = {
  getSummary: (params?: { from?: string; to?: string; top?: number }) =>
    axios
      .get(`/api/platform/usage/summary`, { params })
      .then((response) => wrapEntity(response.data))
      .catch((error) => ({
        hasError: true,
        result: null,
        errorMessages: [
          error?.response?.data?.title ||
            error?.message ||
            'Használati összefoglaló betöltése sikertelen',
        ],
      })),

  getTenantUsage: (
    tenantId: string,
    params?: { from?: string; to?: string }
  ) =>
    axios
      .get(`/api/platform/usage/tenants/${tenantId}`, { params })
      .then((response) => wrapEntity(response.data))
      .catch((error) => ({
        hasError: true,
        result: null,
        errorMessages: [
          error?.response?.data?.title ||
            error?.message ||
            'Használati adatok betöltése sikertelen',
        ],
      })),
};

export default platformUsageService;

export {
  formatBytes,
  formatCount,
  formatUsageDate,
  deviceUtilizationPct,
  severityColor,
  normalizeOperatorAlerts,
  readContentInventory,
  CONTENT_INVENTORY_LABELS,
} from './usageFormat';
export type { OperatorAlert, UsageSeverity } from './usageFormat';
